// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"10089c44","307":"a3189f83","488":"11bf6f92","624":"a8c202b4","766":"04af8cf3"}[chunkId] + ".chunk.js";
};